import { create } from 'zustand';
import { ConversationFilters } from '../types/models/whatsapp';

/**
 * UI state only. Server data (conversations, messages) stays in the Firestore
 * subscription callbacks — mirroring it here would just be a stale second copy.
 */
interface InboxState {
  selectedConversationId: string | null;
  filters: ConversationFilters;
  /** Per-conversation composer drafts, so switching threads doesn't lose text. */
  drafts: Record<string, string>;
  contextPanelOpen: boolean;

  selectConversation: (id: string | null) => void;
  setFilters: (filters: Partial<ConversationFilters>) => void;
  resetFilters: () => void;
  setDraft: (conversationId: string, text: string) => void;
  clearDraft: (conversationId: string) => void;
  toggleContextPanel: () => void;
}

const DEFAULT_FILTERS: ConversationFilters = {
  status: 'open',
  assigneeId: 'all',
  tags: [],
  search: '',
  windowState: 'all',
  unreadOnly: false,
  botState: 'all'
};

export const useInboxStore = create<InboxState>((set) => ({
  selectedConversationId: null,
  filters: DEFAULT_FILTERS,
  drafts: {},
  contextPanelOpen: true,

  selectConversation: (id) => set({ selectedConversationId: id }),

  setFilters: (filters) =>
    set((state) => ({ filters: { ...state.filters, ...filters } })),

  resetFilters: () => set({ filters: DEFAULT_FILTERS }),

  setDraft: (conversationId, text) =>
    set((state) => ({ drafts: { ...state.drafts, [conversationId]: text } })),

  clearDraft: (conversationId) =>
    set((state) => {
      const drafts = { ...state.drafts };
      delete drafts[conversationId];
      return { drafts };
    }),

  toggleContextPanel: () =>
    set((state) => ({ contextPanelOpen: !state.contextPanelOpen }))
}));

export default useInboxStore;
